import param from 'jquery-param';

export default class UrlBuilder {
  static buildUrl(base, path, parameters = {}) {
    return `${base}${path}?${param(parameters)}`;
  }

  static buildWidgetV2Url(base, path, brickConfig) {
    const apiKey = brickConfig.apiKey;
    const partnerAssetId = brickConfig.partnerAssetId;
    const parameters = {
      api_key: apiKey,
      version: 2,
    };

    if (partnerAssetId) {
      parameters.partner_asset_id = partnerAssetId
    }

    return UrlBuilder.buildUrl(base, path, parameters);
  }
}



// WEBPACK FOOTER //
// ./~/url-builder/src/url-builder.js